import styled from '@emotion/styled';
import {ReactComponent as ArrowRightSVG} from '../../../../assets/icons/ic_arrow_right.svg';

export const CardNoActiveItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.lg};
  height: 244px;
  padding: ${({theme}) => theme.padding.desktop.xl};
`;

export const CardNoActiveItemTop = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const IconArrowRight = styled(ArrowRightSVG)`
  width: ${({theme}) => theme.icon.size.md};
  height: ${({theme}) => theme.icon.size.md};
  fill: ${({theme}) => theme.color.primary};
`;
